import { CookieStorage } from 'cookie-storage'
import jwtDecode from 'jwt-decode'
import ApolloClientService from './ApolloClientService'
const TOKEN = 'token'
const REFRESH_TOKEN = 'refreshToken'
const SSO_TOKEN = 'ssoToken'

export const makeCookieStorage = () => {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const expires = new Date(year + 200, month, day)
  return new CookieStorage({
    expires
  })
}
const cookieStorage = makeCookieStorage()
const getStorageAuthKey = key => (key)
export const getSSOToken = () => cookieStorage.getItem(getStorageAuthKey(SSO_TOKEN))
export const getAccessToken = () => cookieStorage.getItem(getStorageAuthKey(TOKEN)) || null
export const getRefreshToken = () => cookieStorage.getItem(getStorageAuthKey(REFRESH_TOKEN))
export const decodedToken = () => (getAccessToken() && jwtDecode(getAccessToken())) || {}
export const decodedSSOToken = () => (getSSOToken() && jwtDecode(getSSOToken())) || {}
export const isDirectToken = () => {
  const { direct } = decodedToken()
  return !!direct
}
export const getUserId = () => decodedToken(getAccessToken()).userId || ''
export const onLogout = () => {
  ApolloClientService.clearCache()
  cookieStorage.clear()
}
export const login = ({ token, refreshToken, ssoToken }) => {
  cookieStorage.setItem(getStorageAuthKey(TOKEN), token)
  cookieStorage.setItem(getStorageAuthKey(REFRESH_TOKEN), refreshToken)
  cookieStorage.setItem(getStorageAuthKey(SSO_TOKEN), ssoToken)
}
export const updateToken = token => {
  cookieStorage.setItem(TOKEN, token)
}
export const updateRefreshToken = refreshToken => {
  cookieStorage.setItem(REFRESH_TOKEN, refreshToken)
}

export const isModerator = () => {
  return !!Number(decodedSSOToken().moderador)
}